export function numberParser(value) {
    if (value) {
        return parseFloat(value.toString().replace(/,/g, '.'))
    } else {
        return value
    }
}